<!-- <span class="header-text">{{ label }}</span> -->
<span class="icons">
    <span class="arrow" [ngClass]="{ active: sortedColumn === column &&  sortDirection === 'asc' }">
        ▲
    </span>
    <span class="arrow" [ngClass]="{ active:sortedColumn === column &&  sortDirection === 'desc' }">
        ▼
    </span>
</span>